import { Component, Input, OnInit } from "@angular/core";
import { UntypedFormControl } from "@angular/forms";
import { Option } from "@recore-solutions/nstar-lib";
import { Observable, of } from "rxjs";
import { listingSotColumnOptions } from "./listing-sort-columns";

@Component({
	selector: "app-listing-sort-select",
	templateUrl: "./listing-sort-select.component.html",
	styleUrls: ["./listing-sort-select.component.scss"],
})
export class ListingSortSelectComponent implements OnInit {
	@Input() control: UntypedFormControl;
	@Input() isSortAscControl: UntypedFormControl;
	@Input() sortByColumns: Array<Option & { className: string; skip?: boolean }>;

	sortByColumn$: Observable<Option[]>;

	constructor() {}

	ngOnInit(): void {
		this.sortByColumns = this.sortByColumns || listingSotColumnOptions;
		this.isSortAscControl =
			this.isSortAscControl || (this.control?.root?.get("isSortASC") as UntypedFormControl);
		this.sortByColumn$ = of(this.sortByColumns);
	}
}
